import React, { MouseEvent, type ReactElement } from 'react';
import IconSearch from './icons/search';

type SuggestBlockProps = {
  searchTerm?: string;
  items: Array<string>;
  label?: string;
  handleSelection: (item: string) => (e: MouseEvent<HTMLButtonElement>) => void;
  highlightTerm?: boolean;
  quoteSelection?: boolean;
};

export default function SuggestBlock({
  searchTerm = '',
  items = [],
  label = '',
  handleSelection,
  highlightTerm = false,
  quoteSelection = false,
}: SuggestBlockProps): ReactElement {
  const surroundWithQuotes = (value: string) => {
    if (quoteSelection) {
      return '"' + value + '"';
    }

    return value;
  };

  return (
    <>
      <strong className="df-autosuggest__suggested-results">{label}</strong>
      <ul className="df-autosuggest__result-list">
        {items.map((item, index) => (
          <li key={`${searchTerm}-${index}-${item}`} className="df-autosuggest__result-list-item">
            <button onClick={handleSelection(surroundWithQuotes(item))}>
              <IconSearch
                width={16}
                height={16}
                className="df-autosuggest__result-list-item__icon"
              />
              {highlightTerm ? (
                <>
                  <strong>
                    {String(item).substring(
                      String(item).indexOf(searchTerm.toLowerCase()),
                      searchTerm.length,
                    )}
                  </strong>
                  {String(item).substring(
                    String(item).indexOf(searchTerm.toLowerCase()) + searchTerm.length,
                  )}
                </>
              ) : (
                item
              )}
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}
